import React from "react";
import "../styles/page-header.css";

/**
 * PageHeader Component
 * ---------------------
 * A reusable hero/header banner for subpages.
 * 
 * Props:
 * - title (string): Optional heading text overlay.
 * - image (string): Path or URL for the background image.
 * - height (string | number): Optional, default is 400px.
 * - overlay (boolean): Whether to show a dark gradient overlay.
 */

const PageHeader = ({
  title,
  image = "https://placehold.co/1440x400",
  height = "200px",
  overlay = true,
}) => {
  return (
    <header
      className="page-header"
      style={{
        backgroundImage: `url(${image})`,
        height: typeof height === "number" ? `${height}px` : height,
      }}
    >
      {overlay && <div className="page-header__overlay"></div>}
      {title && <h1 className="page-header__title">{title}</h1>}
    </header>
  );
};

export default PageHeader;
